import { render, staticRenderFns } from "./RewardsCatalog.vue?vue&type=template&id=c568982c&"
import script from "./RewardsCatalog.vue?vue&type=script&lang=js&"
export * from "./RewardsCatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports